document.addEventListener('DOMContentLoaded', function() {
    if ((document.body.classList.contains('body-products') || document.body.classList.contains('body-circuits')) && document.body.classList.contains('mobile')) {
        var buttons = document.querySelectorAll('.btn.btn-secondary.btn-sm.with-resume-left-sm');

        buttons.forEach(function(button) {
            button.addEventListener('click', function(event) {
                var cardDetails = button.closest('.card-details');

                if (cardDetails) {
                    var description = cardDetails.querySelector('.card-description.with-activity-selected');

                    if (description) {
                        if (description.style.display === 'none' || description.style.display === '') {
                            description.style.display = 'block';
                        } else {
                            description.style.display = 'none';
                        }
                    }
                }
            });
        });
    }
});
